import { RowData, RowSelectionState, Table } from '@tanstack/react-table'
import { useImperativeHandle } from 'react'

export interface TableSelectionRef<T> {
  getSelectedRows: () => T[]
  clearSelection: () => void
  getRowSelection: () => RowSelectionState
  getSelectedCount: () => number
}

interface UseTableSelectionRefProps<T extends RowData> {
  ref: React.Ref<TableSelectionRef<T>> | undefined
  table: Table<T>
  rowSelection: RowSelectionState
  setRowSelection: (selection: RowSelectionState) => void
}

export function useTableSelectionRef<T extends RowData>({
  ref,
  table,
  rowSelection,
  setRowSelection,
}: UseTableSelectionRefProps<T>) {
  useImperativeHandle(
    ref,
    () => ({
      getSelectedRows: () => table.getSelectedRowModel().rows.map((row) => row.original),
      clearSelection: () => setRowSelection({}),
      getRowSelection: () => rowSelection,
      getSelectedCount: () => Object.keys(rowSelection).filter((key) => rowSelection[key]).length,
    }),
    [table, rowSelection, setRowSelection],
  )
}
